import axios from '@/apis/axios';
import { transformObjectValuesToUpperCase } from '@/transformer/transform';

class CompanyNomineeDirector 
{
    static async all()
    {
        const response = await axios.get('api/company/nominee-directors');
        return response.data.data;
    }

    static async allIncludingPendingNomineeDirectors()
    {
        const response = await axios.get('api/company/nominee-directors/including-pending-nominee-directors');
        return response.data.data;
    }

    static async getNominatorTypeOptions()
    {
        const response = await axios.get('api/company/nominee-directors/nominator-type-options');
        return response.data.data;
    }

    static async create(data)
    {       
        const response = await axios.post('api/admin/company/nominee-director', transformObjectValuesToUpperCase(data));
        return response.data.data;
    }

    static async update(id, data)
    {       
        const response = await axios.put(`api/admin/company/nominee-director/${id}`, transformObjectValuesToUpperCase(data));
        return response;
    }

    static async delete(id)
    {
        const response = await axios.delete(`api/admin/company/nominee-director/${id}`);
        return response;
    }
}
export default CompanyNomineeDirector;